// Import Buildings page - this is now the only screen shown
import BuildingsPage from "./BuildingsPage"

/**
 * Member Management Page
 * 
 * Simplified to show only Buildings list by default.
 * When user clicks on a building, they navigate to BuildingDetailPage
 * which shows Units and Residents tabs for that specific building.
 */
export default function MemberManagementPage() {
  return (
    <div className="space-y-5 sm:space-y-6 relative">
      {/* Soft ambient background */}
      <div className="pointer-events-none absolute inset-0 -z-10 bg-[radial-gradient(1200px_600px_at_50%_-10%,rgba(31,58,147,0.06),transparent_60%)]" />

      {/* Show Buildings Page */}
      <BuildingsPage />
    </div>
  )
}
